import type { PropsWithChildren } from 'react';

import authLogo from '@iconik-io/shared-lib/src/images/iconik-backlight-dark.svg';

import styles from '../../../components/auth/auth.module.css';
import themes from '../../../ui/forms/themes.module.css';

export function LayoutLoginScreen(props: PropsWithChildren) {
  return (
    <div className={themes.auth}>
      <img src={authLogo} className={styles.logo} alt="iconik logo" />
      {props.children}
    </div>
  );
}
